export default state => state.getIn(['cashInPrices', 'betIds']);
